/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 立会者情報
 */
export interface Sgkb575aResTaiperInfo {
    /** 
     * 立会有無フラグ：半角英数混在
     */
    tatiaiEonflg?: string;
    /** 
     * 立会有無フラグ名称：全角半角混在
     */
    tatiaiEonflgAname?: string;
    /** 
     * 立会希望日付（電気）：日付YYYYMMDD
     */
    tachiaikiboDateElec?: string;
    /** 
     * 立会希望時刻（電気）：半角英数混在
     */
    tachiaikiboHmsElec?: string;
    /** 
     * 立会希望時刻名称（電気）：全角半角混在
     */
    tachiaikiboTimezanameElec?: string;
    /** 
     * 立会者区分コード：半角英数混在
     */
    taiperDivcd?: string;
    /** 
     * 立会者区分コード名称：全角半角混在
     */
    taiperDivCodeaname?: string;
    /** 
     * 立会者漢字氏名：全角文字
     */
    taiperName?: string;
    /** 
     * 立会者電話番号コード：半角英数混在
     */
    taiperTeldv?: string;
    /** 
     * 立会者電話番号コード名称：全角半角混在
     */
    taiperTeldvAname?: string;
    /** 
     * 立会者電話番号：電話番号(ハイフンと数値含む)
     */
    taiperTelNo?: string;
}
